import _ from "underscore";
import Vue from "vue";

import { BaseApiError } from "@/errors/api/base-api-error";
import { ServiceCategoryInterface } from "@/interfaces/service-category.interface";

export class ServiceService {
  /**
   * サービスカテゴリ一覧を取得する
   */
  async getCategories(
    vue: Vue,
    options = {}
  ): Promise<ServiceCategoryInterface[]> {
    if (vue.$store.state.service.serviceCategories.length > 0) {
      return vue.$store.state.service.serviceCategories;
    }

    vue.showLoading();
    return vue.$api
      .getServiceCategories()
      .then((items: ServiceCategoryInterface[]) => {
        vue.$store.commit("service/setServiceCategories", items);
        vue.hideLoadingIfNoOthers();

        return items;
      })
      .catch((e: BaseApiError) => {
        throw e;
      });
  }

  /**
   * ルートキーからカテゴリを取得する
   */
  getCategoryByRouteKey(
    categories: ServiceCategoryInterface[],
    routeKey: string
  ): ServiceCategoryInterface | null {
    return (
      _.find(
        categories,
        (c: ServiceCategoryInterface) => c.routeKey === routeKey
      ) || null
    );
  }
}
